import React, { useEffect, useState } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import CreateMarketingActivityFilter from '../../filters/CreateMarketingActivityFilterNew';
import CenterSpinner from '../../components/CenterSpinner';
import {
  CreateMarketActivityFilterType,
  EmployeeResultType,
  LocationFilterInitialState,
  MapOptionType,
  SelectOptionType,
  SetMarketActivityFilterType,
  SuggestionsType,
} from '../../utils/Types';
import MSelect from '../../components/MSelect';
import MDatePicker from '../../components/MDatePicker';
import { MARKET_ACTIVITY_FILTER_INIT } from '../../utils/Constant';
import {
  AssigneeColumnHeader,
  moduleIds,
  listTypes,
  onSelectEmployeeChange,
  getMarketingActivityOnIdChange,
  getVillages,
  onSubmitFilter,
  handleCreate,
} from './activityHelper';
import MarketingActivitySucessModal from '../modals/MarketingActivitySuccessModal';
import MAutoCompleteMultiSelect from '../../components/MAutoCompleteMultiSelect';

import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  fetchTargetDrops,
  marketingActivitySelector,
} from '../../features/marketingActivitySlice';
import moment from 'moment';
import { locationFilterSelector } from '../../features/locationFilterSlice';
import ToggleSwitch from '../../components/ToggleSwitch';
import classNames from 'classnames';
import KTable from '../../components/KTable';
import { Image } from 'react-bootstrap';
import Calendar from '../../assets/img/calendar.svg';
import { useLoader } from '../../loader/LoaderProvider';

const CreateMarketingActivityPage: React.FunctionComponent = () => {
  const [stateOption, setStateOption] = useState<SelectOptionType[]>([]);
  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOption: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;

  const { showLoader, setShowLoader } = useLoader();
  const [selectedEmployees, setSelectedEmployees] = useState<SuggestionsType[]>(
    []
  );
  const [selectedEmployeesDetails, setSelectedEmployeesDetails] = useState<
    EmployeeResultType[]
  >([]);
  const employeeList = useAppSelector(marketingActivitySelector).employeeList;
  const marketingTypes = useAppSelector(
    marketingActivitySelector
  ).marketingTypes;
  const [optionEmployeeName, setOptionEmployeeName] = useState<
    SuggestionsType[] | []
  >([]);
  const [filterValues, setFilterValues] = useState<SetMarketActivityFilterType>(
    MARKET_ACTIVITY_FILTER_INIT
  );
  const [filterData, setFilterData] =
    useState<CreateMarketActivityFilterType>();
  const [primaryEmpUniqueId, setPrimaryEmpUniqueId] = useState<any>();
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [showAssignees, setShowAssignees] = useState<boolean>(false);
  const [createdActivityId, setCreatedActivityId] = useState<string | number>();
  const [createdActivity, setCreatedActivity] = useState<any>();
  const [activityDate, setActivityDate] = useState(
    moment(new Date()).add(10, 'minutes').format('DD-MM-YYYY H:mm A')
  );
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchTargetDrops({ module: moduleIds.marketingTypes }));
  }, []);

  useEffect(() => {
    if (!showAssignees) {
      setSelectedEmployees([]);
    } else {
      setActivityDate(
        moment(new Date()).add(10, 'minutes').format('DD-MM-YYYY H:mm A')
      );
    }
  }, [showAssignees]);

  useEffect(() => {
    const employeeOptions: SuggestionsType[] = [];
    employeeList.map((emp) => {
      employeeOptions.push({
        label: emp.employeeName,
        value: emp.employeeId,
        id: emp.employeeUniqueId,
      });
    });
    setOptionEmployeeName(employeeOptions);
  }, [employeeList]);

  useEffect(() => {
    onSelectEmployeeChange(
      selectedEmployees,
      employeeList,
      primaryEmpUniqueId,
      setPrimaryEmpUniqueId,
      setSelectedEmployeesDetails
    );
  }, [selectedEmployees]);

  useEffect(() => {
    getMarketingActivityOnIdChange(
      createdActivityId,
      setShowLoader,
      dispatch,
      setCreatedActivity
    );
  }, [createdActivityId]);
  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );

  useEffect(() => {
    getVillages(employeeList, locationData, dispatch);
  }, [employeeList]);

  const handleReset = () => {
    const newFilter = { ...MARKET_ACTIVITY_FILTER_INIT };
    if (stateOption && stateOption.length === 1) {
      newFilter.state = stateOption[0].value;
    }
    if (zoneOption && zoneOption.length === 1) {
      newFilter.zone = zoneOption[0].value;
    }
    setFilterValues(newFilter);
    setFilterData(newFilter);
    setShowAssignees(false);
    setPrimaryEmpUniqueId(null);
  };

  const handleModalClose = () => {
    handleReset();
    setOpenSuccessModal((prevState) => !prevState);
  };
  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };
  useEffect(() => {
    if (zoneOption && zoneOption.length === 1) {
      const stateArray = allStates[zoneOption[0].value];
      setStateOption(stateArray);
      const newFilter = { ...filterValues, zone: zoneOption[0].value };
      if (stateArray?.length === 1) {
        newFilter.state = stateArray[0].value;
      }
      setFilterValues(newFilter);
    }
  }, [zoneOption]);
  return (
    <div className="ml-4">
      <Label className="text-heading">Create Sales Activity</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
      <div>
        {showFilter && (
          <CreateMarketingActivityFilter
            filterValues={filterValues}
            onReset={handleReset}
            setFilterValues={setFilterValues}
            listType={listTypes.create}
            onSubmitFilter={(isValid?: boolean) => {
              onSubmitFilter(
                isValid ?? false,
                filterValues,
                setShowAssignees,
                setFilterData,
                dispatch,
                setSelectedEmployees
              );
            }}
          />
        )}

        {showAssignees && (
          <div
            className={classNames(
              'mt-3 container-parent parent-table create-marketing',
              {
                hideFilters: !showFilter,
              }
            )}
          >
            <div className="marketing-inner-div">
              <Label className="header-style">Assigned To</Label>
              <span className="text-danger">{` * `}</span>
              <span className="subtitle">
                (You can assign upto 6 employees)
              </span>
              <Row className="mt-2">
                <Col xs={12} md={4}>
                  <MAutoCompleteMultiSelect
                    placeholder="Employee Name"
                    suggestions={optionEmployeeName}
                    value={selectedEmployees}
                    onChange={setSelectedEmployees}
                    noSuggestionsText={'No options'}
                    maxSelectable={6}
                  />
                </Col>
              </Row>

              <KTable
                data={selectedEmployeesDetails}
                tableParentClass="table-parent-assign-employee mt-2"
                columnHeader={AssigneeColumnHeader}
                isLoading={showLoader}
                primaryEmpUniqueId={primaryEmpUniqueId}
                onAction={(emp) => {
                  setPrimaryEmpUniqueId(emp.employeeId);
                }}
                locationData={locationData}
                showNoDataFoundMsg={false}
                showHeader
              />
            </div>

            <div className="mt-3">
              <div className="marketing-inner-div">
                <Label className="header-style">Type of Sales Activities</Label>
                <span className="text-danger">{` * `}</span>
                <Row>
                  <Col xs={6} md={4}>
                    <MSelect
                      label="Type of Sales Activity"
                      options={marketingTypes}
                      value={filterData?.marketingActivityType}
                      onChange={(e) => {
                        setFilterData((prev: any) => ({
                          ...prev,
                          marketingActivityType: e.target.value,
                        }));
                      }}
                      dataTestId="type"
                      hideLabel={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <Row className="d-flex flex-grow-1">
              <Col xs={12} md={6}>
                <div className="date-activity date-activity-left">
                  <Label className="header-style">Activity Date & Time</Label>
                  <span className="text-danger">{` * `}</span>
                  <Row className="mt-2 mb-4">
                    <Col>
                      <MDatePicker
                        label=""
                        value={activityDate}
                        onChange={(e) => {
                          setActivityDate(e);
                        }}
                        disablePast
                        format="DD-MM-YYYY hh:mm A"
                        icon={<Image src={Calendar}></Image>}
                        maxDate={moment().add(90, 'days')}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col>
                <div className="date-activity date-activity-right pb-1">
                  <div>
                    <Label for="comment" className="header-style mb-0">
                      Comments
                    </Label>
                    <FormGroup>
                      <Input
                        id="comment"
                        name="comment"
                        type="textarea"
                        maxLength={250}
                        value={filterData?.comment}
                        placeholder="Please enter comments"
                        className="rounded border model-comment-area"
                        onChange={(e) => {
                          if (e.target.value?.length <= 250)
                            setFilterData((prev: any) => ({
                              ...prev,
                              comment: e.target.value,
                            }));
                        }}
                      />
                    </FormGroup>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-center mt-4 mb-2">
              <Button
                variant="primary"
                className="cl-btn-primary mt-2"
                disabled={showLoader}
                onClick={() => {
                  handleCreate(
                    {
                      activityDate,
                      selectedEmployees,
                      filterData,
                      primaryEmpUniqueId,
                    },
                    setShowLoader,
                    dispatch,
                    setCreatedActivityId,
                    setOpenSuccessModal
                  );
                }}
              >
                Create
              </Button>
              <Button
                variant="primary-outline"
                className="mt-2 mx-4 cl-btn-outline-primary "
                onClick={handleReset}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>

      <CenterSpinner showLoader={showLoader} className="spinner-60" />

      <MarketingActivitySucessModal
        isOpen={openSuccessModal}
        toggleSuccessModal={() => handleModalClose()}
        type={listTypes.create}
        activityDetails={createdActivity}
      />
    </div>
  );
};

export default CreateMarketingActivityPage;
